import React from "react";
import { COMPLIANCE_MATRIX } from "../../data/site";

const STATUS_COLOR = {
  "IMPLEMENTED": { dot: "bg-emerald-400", text: "text-emerald-400" },
  "ALIGNED": { dot: "bg-cyan-400", text: "text-cyan-400" },
  "IN REVIEW": { dot: "bg-amber-400", text: "text-amber-400" },
};

export default function ComplianceMatrix({ SectionHeader }) {
  const total = COMPLIANCE_MATRIX.reduce((a, b) => a + b.controls, 0);
  return (
    <section id="compliance" className="relative py-24 md:py-32 px-6 md:px-10 border-t border-slate-800/50">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          index="05"
          kicker="Control Coverage"
          title="Framework alignment, at a glance."
          description="A snapshot of the frameworks against which our reference architecture is designed. Control counts reflect the moderate baseline unless otherwise annotated."
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-800/60 border border-slate-800/60 reveal">
          {COMPLIANCE_MATRIX.map((c) => {
            const s = STATUS_COLOR[c.status];
            return (
              <div key={c.name} className="bg-slate-950 hover:bg-slate-900/70 transition-colors p-5 group">
                <div className="flex items-center justify-between mb-4">
                  <span className="font-mono text-[10px] tracking-widest text-slate-500 uppercase">{c.family}</span>
                  <span className={`font-mono text-[9px] tracking-[0.2em] ${s.text} flex items-center gap-1.5`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />{c.status}
                  </span>
                </div>
                <div className="text-sm text-slate-100 font-medium leading-snug tracking-tight mb-6">{c.name}</div>
                <div className="flex items-end justify-between">
                  <div>
                    <div className="font-mono text-[10px] text-slate-500 tracking-widest uppercase mb-1">Controls</div>
                    <div className="font-mono text-lg text-slate-200">{c.controls}</div>
                  </div>
                  <svg width="52" height="20" viewBox="0 0 52 20" className="opacity-60 group-hover:opacity-100 transition-opacity">
                    {Array.from({ length: 13 }).map((_, i) => (
                      <rect
                        key={i}
                        x={i * 4}
                        y={20 - ((i * 37 + c.controls) % 18) - 2}
                        width="2"
                        height={((i * 37 + c.controls) % 18) + 2}
                        fill="#38bdf8"
                        opacity={0.35 + (i % 5) * 0.12}
                      />
                    ))}
                  </svg>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-slate-800 pt-4">
          <div className="font-mono text-[10px] tracking-[0.25em] text-slate-500 uppercase">
            Aggregate {total.toLocaleString()} controls tracked across {COMPLIANCE_MATRIX.length} frameworks
          </div>
          <div className="flex items-center gap-4 font-mono text-[10px] tracking-[0.2em] uppercase">
            <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />Implemented</span>
            <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />Aligned</span>
            <span className="flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-amber-400" />In review</span>
          </div>
        </div>
      </div>
    </section>
  );
}
